<template>
    <th v-if="athConfig.isBibEnabled" class="bib">{{ $getStrByLng().HEADER_BIB }}</th>
</template>
<script setup lang="ts">
import { useAthStore } from "../../../stores/ath.store";

const { athConfig } = useAthStore();
</script>
